import { getData } from '@/apis';
import { IBaAdminChargeErrorResponse } from '~/types/xba/IBaAdminResponse';

type IBaAdminApis = {
  getBaAdminChargeErrors: () => Promise<IBaAdminChargeErrorResponse>;
}

/**
 * baAdmin APIs
 */
export const baAdminApis = (): IBaAdminApis => {
  const getBaAdminChargeErrors = async (): Promise<IBaAdminChargeErrorResponse> => {
    try {
      const data = await getData(process.env.BA_ADMIN_URL + '/api/charge/errors', {}, {});

      if (data.status !== 'success') {
        throw new Error(data?.result?.error_messages || 'アラート対象課金データの取得に失敗しました');
      }

      return data;
    } catch (error) {
      console.error('アラート対象課金データの取得に失敗しました', error);
      throw error;
    }
  };

  return {
    getBaAdminChargeErrors
  };
};
